import { useQuery, useMutation } from 'react-query';
import axios from 'axios';
import { logActivity } from '../helpers/logActivity.helper';
import config from '../config';

export const usePaymentManager = () => {
  // MUTATION QUERY - make payment
  const makePaymentMutation = useMutation(async paymentDetails => {
    const paymentData = new FormData();
    paymentData.append('mode', 'handlePayment');
    paymentData.append('studentId', paymentDetails?.student_id);
    paymentData.append('paymentValue', paymentDetails?.value);
    paymentData.append('auth', localStorage.getItem('token'));

    const output = await axios.post(config.STUDENTS_API, paymentData);
    if (output?.data?.response?.status === 'OK') {
      logActivity(
        `Set payment for ${paymentDetails?.student_name} (${paymentDetails?.student_id}) - $${paymentDetails?.value}`
      );
    }
  });
  const paymentLoader = makePaymentMutation.isLoading;

  const makePayment = (student_id, student_name, refetch) => {
    if (
      document.getElementById('paymentValueField_' + student_id).value === ''
    ) {
      return;
    }

    makePaymentMutation.mutate(
      {
        student_id,
        student_name,
        value: document.getElementById('paymentValueField_' + student_id).value,
      },
      {
        onSuccess: () => {
          if (refetch) {
            refetch();
          }
        },
      }
    );
  };

  // MUTATION #2 - Update Financial Assistance Flag
  const updateFAMutation = useMutation(async payload => {
    const data = new FormData();
    data.append('mode', 'updateFinancialAssistance');
    data.append('studentId', payload.student_id);
    data.append('faState', +payload.fa);
    data.append('auth', localStorage.getItem('token'));
    const output = await axios.post(config.STUDENTS_API, data);
    // return output?.data?.response?.status;
  });

  const handleFAUpdate = (student_id, fa) => {
    console.log('received: ' + +fa);
    updateFAMutation.mutate({ student_id, fa });
  };

  return { makePayment, paymentLoader, handleFAUpdate };
};
